import { useTranslation } from 'react-i18next'

import { Button, Menu, MenuItem } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'

import { PatientSourceEnum } from '@/core/enums/patient-source.enum'

type PatientSourceMenuProps = {
  onChange?: (source: PatientSourceEnum) => void
  value?: PatientSourceEnum
}

export function PatientSourceMenu({ onChange, value }: PatientSourceMenuProps) {
  const { t } = useTranslation()
  return (
    <PopupState variant="popover" popupId="patient-source-menu">
      {(popupState) => (
        <>
          <Button variant="contained" {...bindTrigger(popupState)}>
            {t('component.ui.patientSourceMenu.label')}
          </Button>
          <Menu {...bindMenu(popupState)}>
            <MenuItem
              selected={value === PatientSourceEnum.MedconnectPatient}
              onClick={() => {
                onChange?.(PatientSourceEnum.MedconnectPatient)
                popupState.close()
              }}
            >
              Promotal
            </MenuItem>
            <MenuItem
              selected={value === PatientSourceEnum.NetsoinsPatient}
              onClick={() => {
                onChange?.(PatientSourceEnum.NetsoinsPatient)
                popupState.close()
              }}
            >
              Netsoins
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  )
}
